// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2N-rG","label":"CategoryService_label__xyBum","location":"CategoryService_location__3oOY3"};